import React from 'react';
import ArticleField from '../ArticleField';
import { ReadSingle, ReadExternItem } from '../ReadExtern';

interface SourceProps {
    value: ReadExternItem,
    onChange: (value: ReadExternItem) => void
}

const Source = (props: SourceProps) => (
    <ArticleField label="Source">
        <ReadSingle value={props.value ?? {linktext: "", linkurl: "", linktitle: ""}} onChange={(v) => {
            props.onChange(v)
        }} />
    </ArticleField>
);

export default Source;
